<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title {{ operatorPageData.title }} "Орленок"
    .profile-page__tabs
      tab-nav(
        v-bind:tabNavData="tabNavData"
        )
    .profile-page__body
      router-view
</template>

<script>
import {mapActions} from "vuex";
import TabNav from "../../../../../components/tabNav/TabNav.vue";

export default {
  name: "OperatorCamp",
  components: {
    TabNav
  },
  data() {
    return {
      tabNavData: {
        tabs: [
          {
            path: "/pages/operator/camp/basic",
            text: "Основная информация"
          },
          {
            path: "/pages/operator/camp/about",
            text: "О лагере"
          },
          {
            path: "/pages/operator/camp/placement",
            text: "Размещение"
          },
          {
            path: "/pages/operator/camp/documents",
            text: "Документы"
          },
          {
            path: "/pages/operator/camp/things",
            text: "Вещи с собой"
          },
          {
            path: "/pages/operator/camp/contacts",
            text: "Контакты"
          }
        ]
      },

      operatorPageData: {
        title: "Лагерь",
        description: ""
        // "Здесь вы можете изменить данные своего профиля, следить за статусом заявки, а так же загрузить все необходимы для подачи заявки документы и информацию о детях"
      },

      shiftsData: []
    };
  },
  methods: {
    ...mapActions(["getShifts", "getCamps"])
  },
  mounted() {
    this.getCamps().then(res => {});
  }
  //   this.getShifts().then(shiftsData => {
  //     this.shiftsData = shiftsData.map(shift => {
  //       shift.camp_url = `/pages/camps/${shift.camp.id}`;
  //       shift.shift_url = `/pages/shifts/${shift.id}`;
  //       shift.camp_name = shift.camp.name;
  //       shift.duration_time = "duration_time";
  //       shift.duration = `${shift.duration} дней`;
  //       shift.date_start = new Date(shift.date_started).toLocaleDateString(
  //         "ru"
  //       );
  //       return shift;
  //     });
  //   });
  // }
};
</script>
